export default function CanadaVisaConsultants() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-10">

                {/* Main Heading */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Canada Student Visa Consultant – Study Visa Application Process
                </h3>

                {/* Intro */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
                    <p>
                        Studying in Canada is a dream for many international students.
                        A professional Canada Student Visa Consultant guides applicants
                        through each stage of the study permit process, ensuring accuracy,
                        compliance, and timely submission.
                    </p>
                    <p>
                        Below are the essential steps involved in applying for a Canadian Study Permit:
                    </p>
                </div>

                {/* Step 1 */}
                <div>
                    <h4 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">
                        1. Obtain Acceptance from a Designated Learning Institution (DLI)
                    </h4>
                    <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify">
                        Before applying for a study permit, you must secure admission
                        from a Canadian college or university that is officially recognized
                        as a Designated Learning Institution (DLI). Only DLIs are authorized
                        by the Canadian government to host international students.
                    </p>
                </div>

                {/* Step 2 */}
                <div>
                    <h4 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">
                        2. Check Eligibility Criteria
                    </h4>
                    <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify mb-3">
                        To qualify for a Canada Student Visa (Study Permit), you must:
                    </p>
                    <ul className="list-disc ml-6 space-y-2 text-gray-800 text-base sm:text-lg">
                        <li>Provide proof of acceptance from a recognized DLI</li>
                        <li>Show sufficient financial funds for tuition, living expenses, and return travel</li>
                        <li>Meet health and security requirements</li>
                        <li>Demonstrate genuine intent to study</li>
                    </ul>
                </div>

                {/* Step 3 */}
                <div>
                    <h4 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">
                        3. Compile Mandatory Documents
                    </h4>
                    <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify mb-3">
                        Proper documentation is critical to avoid delays or rejection.
                        Required documents typically include:
                    </p>
                    <ul className="list-disc ml-6 space-y-2 text-gray-800 text-base sm:text-lg">
                        <li>Valid Passport</li>
                        <li>Letter of Acceptance from DLI</li>
                        <li>Proof of Financial Support</li>
                        <li>Academic Transcripts & Certificates</li>
                        <li>Proof of Language Proficiency (IELTS / PTE / TOEFL)</li>
                        <li>Medical Examination (if required)</li>
                        <li>Statement of Purpose (SOP)</li>
                    </ul>
                </div>

                {/* Step 4 */}
                <div>
                    <h4 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">
                        4. Submit the Application & Pay Fees
                    </h4>
                    <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify">
                        Complete your study permit application carefully through the
                        official Immigration, Refugees and Citizenship Canada (IRCC)
                        portal or via a Visa Application Centre (VAC).
                        Ensure all details are accurate and up to date, and pay
                        the required visa processing fee as per the latest guidelines.
                    </p>
                </div>

                {/* Step 5 */}
                <div>
                    <h4 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">
                        5. Wait for Decision & Receive Study Permit
                    </h4>
                    <p className="text-gray-800 text-base sm:text-lg leading-relaxed text-justify">
                        Processing times vary depending on your country and
                        the time of year, typically ranging from 5 to 60 days.
                        Upon approval, you will receive a Port of Entry (POE)
                        Introduction Letter, which allows you to travel to Canada
                        and obtain your official Study Permit upon arrival.
                    </p>
                </div>

                {/* Closing */}
                <div className="text-justify text-gray-800 text-base sm:text-lg leading-relaxed">
                    <p>
                        With the guidance of an experienced Canada Student Visa Consultant,
                        students can confidently complete their application process,
                        reduce errors, and significantly improve their chances of approval.
                    </p>
                </div>

            </div>
        </section>
    );
}